import { Typography, Stack } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import BoxIcon from '@shared/components/BoxIcon';
import AppTheme from '@libs/mui/AppTheme';
import { Paths } from '@shared/AppRoutes';
import { Client } from '../entity';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { formatPhoneNumber } from '@shared/entity';

export const createClientListColumns = (
  navigate: (path: string) => void,
): GridColDef<Client[][number]>[] => [
  {
    field: 'name',
    headerName: 'client.name',
    flex: 5,
    display: 'flex',
    disableColumnMenu: true,
    renderCell: params => (
      <Typography
        sx={{ color: '#888', marginLeft: 0 }}
      >{`${params.row.lastName} ${params.row.firstName}`}</Typography>
    ),
  },
  {
    field: 'phone',
    headerName: 'client.phone',
    flex: 5,
    display: 'flex',
    disableColumnMenu: true,
    renderCell: params => (
      <>
        <Typography sx={{ color: '#888', marginLeft: 0 }}>
          {formatPhoneNumber(params.row.phone)}
        </Typography>
      </>
    ),
  },
  {
    field: 'edit',
    headerName: '',
    editable: false,
    flex: 2,
    display: 'flex',
    disableColumnMenu: true,
    renderCell: params => (
      <Stack direction="row" spacing={2}>
        <BoxIcon
          size="medium"
          onClick={() => navigate(Paths.clientDetail(params.row.id))}
          sx={{
            background: `${AppTheme.palette.primary.light}`,
            color: `${AppTheme.palette.info.main}`,
          }}
          icon={<ManageAccountsOutlinedIcon fontSize="small" color="primary" />}
        />
      </Stack>
    ),
  },
];
